import { OrderMaster } from '../types';

type page = {
  lastPage: number;
  page: number;
  pageSize: number;
  total: number;
};

// export type orderDetailType = Omit<OrderMaster, 'user' | 'transactions'> & {
export type orderDetailType = Omit<OrderMaster, 'user'> & {
  created_at: string;
  updated_at: string;
};

export type orderList = {
  page: page;
  result: orderDetailType[];
};

// 포인트 사용/적립 유형
export enum PointUsageType {
  DEPOSIT = 'DEPOSIT', // 구매 적립
  MEMBERSHIP_DEPOSIT = 'MEMBERSHIP_DEPOSIT', // 멤버십 등급 적립
  REGISTRATION_DEPOSIT = 'REGISTRATION_DEPOSIT', // 회원가입 적립
  OFFICE_DEPOSIT = 'OFFICE_DEPOSIT', // 관리자 적립
  WITHDRAW = 'WITHDRAW', // 포인트 사용
  REFUND = 'REFUND', // 환불
  EXPIRE = 'EXPIRE', // 포인트 소멸
}

// 포인트 이력 구분
export enum PointType {
  EARN = 'EARN', // 적립
  USE = 'USE', // 사용
}

// 포인트 상태
export enum PointStatus {
  PENDING = 'PENDING', // 대기
  ACTIVE = 'ACTIVE', // 사용가능
  USED = 'USED', // 사용완료
  CANCELED = 'CANCELED', // 취소
  EXPIRED = 'EXPIRED', // 소멸
}

// 포인트 발생 출처
export enum PointTransactionSource {
  SHOP = 'SHOP', // 쇼핑몰(고객주문)
  MANUAL = 'MANUAL', // 수동적립(관리자)
  ETC = 'ETC', // 기타
}

export type pointType = {
  /* 3세대 포인트 데이터 */
  id: string; // 이력 ID (point_earn 또는 point_usage의 ID)
  description: string; // 고객 노출 텍스트
  relatedOrderId: string; // 구매 정보. 상세 구매내역으로 연결 처리 필요
  amount: number; // 포인트 변동량 ( 차감은 음수 )
  status: PointStatus; // canceled의 경우 삭선 처리
  registerAt: Date; // 적립일
  expiryAt: Date | null; // 만료일

  /* 2세대 포인트 데이터 */
  // type: PointType; //포인트 이력 구분
  // id: string; // 이력ID(point_earn 또는 point_usage의 ID)
  // registerAt: Date; // 포인트 적립 또는 사용 일자
  // amount: string; //적립(양수) 또는 사용(음수) 포인트
  // balance: number | null; // 적립 이력의 잔액 (사용 이력일 경우 null)
  // usageType: PointUsageType; // 포인트 사용/적립 유형
  // description: string; // 포인트 사용/적립 설명
  // status: PointStatus; //포인트 상태
  // source: PointTransactionSource; //포인트 발생 출처
  // mappingCount: number | null; //사용 이력일 경우 적립과의 매핑 횟수(적립 이력일 경우 null)
  // relatedOrderId: string | null; //관련주문ID(존재할 경우)
  // userId: string; //해당 이력의 사용자ID
  // expiryAt: Date | null; //포인트 유효기간
  // userGradeSnap?: number;
  // transactionType?: string;
  // transactionSource?: string;
  // transactionBaseId?: string;
  // expireDate?: Date;
  // lastApprovedDate?: Date;
  // createdAt?: Date;
  // updatedAt?: Date;
};

export type pointList = {
  page: page;
  result: {
    balance: number;
    transactions: pointType[];
  };
};

export type churchDataType = {
  id: string;
  churchName: string;
  address: string;
  tel: string;
  pastorName: string;
  denomination: denominationType;
  createdAt: Date | null;
  updatedAt: Date | null;
  deletedAt: Date | null;
};

export type denominationType = {
  id: string;
  denominationName: string;
  createdAt: Date | null;
  updatedAt: Date | null;
  deletedAt: Date | null;
};

export type fileType = {
  id: string;
  type: string;
  size: number;
  resource_path: string;
  origin_file_name: string;
  access_url: string;
  need_permission: boolean;
  is_draft: boolean;
  created_at: Date;
  updated_at: Date;
};

export type TeacherLicenseType = {
  id: string;
  coursedId: string;
  courseName: string;
  learningId: string;
  userId: string;
  userName: string;
  userEnglishName: string;
  graduationAt: Date;
  licenseType: CertificateImgEnum;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

export enum CertificateImgEnum {
  HOME_SCHOOL_KIDS = 'HOME_SCHOOL_KIDS', // 키즈
  HOME_SCHOOL_BASIC = 'HOME_SCHOOL_BASIC', // 베이직
  HOME_SCHOOL_ADVANCED = 'HOME_SCHOOL_ADVANCED', // 어드밴스드
  WORSHIP_HFHJ = 'WORSHIP_HFHJ', // 헬로우파더, 헬로우지지스
  WORSHIP_WMW = 'WORSHIP_WMW', // 후메이드더월드
  WORSHIP_DANIEL = 'WORSHIP_DANIEL', // 다니엘의 세 친구
  SMALL_GROUP_JOHN = 'SMALL_GROUP_JOHN', // 요한복음
  SMALL_GROUP_JAMES = 'SMALL_GROUP_JAMES', // 야고보서
  SMALL_GROUP_JOHN_1 = 'SMALL_GROUP_JOHN_1', // 요한일서
  SMALL_GROUP_JONAH = 'SMALL_GROUP_JONAH', // 요나서
  SMALL_GROUP_GPS = 'SMALL_GROUP_GPS', // 영어로 복음 전하기(GPS)
  SMALL_GROUP_RBE = 'SMALL_GROUP_RBE', // 성경말씀 영어로 암송하기
}
